/** Mirrors backend APPROVAL_SLA_REQUEST_TYPES — used only for employee-facing SLA. */
export const APPROVAL_SLA_REQUEST_TYPES = [
  "leave",
  "overtime",
  "weekly_rest",
  "permit",
  "wfh",
  "timesheet",
  "inventory_night",
];
